import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52f86e9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "skills" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  "data-aos": "slide-up",
  "data-aos-easing": "ease"
}, [
  /*#__PURE__*/_createElementVNode("ins", null, "Skills")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkillSet = _resolveComponent("SkillSet")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_SkillSet, {
      skillName: "Front End",
      skillSet: _ctx.frontEndTechnologies
    }, null, 8, ["skillSet"]),
    _createVNode(_component_SkillSet, {
      skillName: "Back End",
      skillSet: _ctx.backEndTechnologies
    }, null, 8, ["skillSet"]),
    _createVNode(_component_SkillSet, {
      skillName: "Cloud",
      skillSet: _ctx.cloudTechnologies
    }, null, 8, ["skillSet"]),
    _createVNode(_component_SkillSet, {
      skillName: "Mobile",
      skillSet: _ctx.mobileTechnologies
    }, null, 8, ["skillSet"])
  ]))
}